export default __webpack_public_path__ + "static/img-app-graphs-2ee4f931c9bffbb6a7c262473a0b7fd7.jpg";